<mat-form-field [floatLabel]="floatLabel"
                appearance=""
                [class.form-slim]="slim">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input [ngModel]="value"
           (ngModelChange)="writeValue($event)"
           [disabled]="disabled"
           [lsnNumeric]="config"
           (blur)="onBlurAction()"
           [errorStateMatcher]="errorStateMatcher"
           matInput type="text">
    <span *ngIf="suffix" matSuffix>{{ suffix }}</span>
    <mat-hint *ngIf="hintEnabled">{{ hint }}</mat-hint>
    <mat-error *ngFor="let error of (errorStateMatcher ? errorStateMatcher.errors : [])">
        {{ error.description ? error.description : error.code }}
    </mat-error>
</mat-form-field>
